module.exports = __webpack_public_path__ + "img/1565767113.ec0bf4b5.jpg";